import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthServiceService } from '../services/auth-service/auth-service.service';

@Injectable()
export class ApiInterceptorInterceptor implements HttpInterceptor {

  constructor(private authService: AuthServiceService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isAuthRequest = request.url.includes('/v1/auth/login') || request.url.includes('/v1/auth/reset-password');
    let token: string | null = this.authService.getToken();
    if (token != null && !isAuthRequest) {
      request = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`
        }
      });
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!isAuthRequest && (error.status === 401 || error.status === 403) && this.authService.isLoggedIn()) {
          this.authService.invalidateSession(
            'Auto Logged Out',
            'You have been logged out because your CMS access is no longer valid.',
          );
        }

        return throwError(() => error);
      })
    );
  }
}
